import 'swiper/css';
import Vue from 'vue';
import {
    getSwiper,
    getSwiperModules,
    handleClickOnDisclaimerLink,
} from '../utils';

Vue.component('homepage-thumb-slider', {
    props: [
        'totalSlides',
        'siteHandle',
        'disablePagination',
        'customSliderClass',
    ],

    data() {
        return {
            currentSlide: 0,
            gallery: null,
        };
    },

    computed: {},

    mounted() {
        window.addEventListener('click', handleClickOnDisclaimerLink);
        this.initSwiper();

        window.addEventListener('resize', this.setScrollbarLeftSizeOffset);
        this.setScrollbarLeftSizeOffset();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.setScrollbarLeftSizeOffset);
    },

    methods: {
        async initSwiper() {
            const { Swiper } = await getSwiper();
            const { Autoplay, Scrollbar, Navigation, Pagination } =
                await getSwiperModules();

            const slider = this.$el.querySelector(
                this.customSliderClass
                    ? `.${this.customSliderClass}`
                    : '.thumbslider__content',
            );

            const swiperScrollbar = slider.querySelector('.swiper-scrollbar');

            this.gallery = new Swiper(
                this.customSliderClass
                    ? `.${this.customSliderClass}`
                    : '.thumbslider__content',
                {
                    slidesPerView: 1.1,
                    spaceBetween: window.screen.width >= 768 ? 32 : 16,
                    modules: [Autoplay, Scrollbar, Navigation, Pagination],
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    noSwiping: false,
                    scrollbar: {
                        enabled: Boolean(swiperScrollbar),
                        el: swiperScrollbar,
                        hide: false,
                        draggable: false,
                    },
                    uniqueNavElements: true,
                    navigation: {
                        nextEl: slider.querySelector('.swiper-button-next'),
                        prevEl: slider.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        enabled: !Boolean(this.disablePagination),
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: (index, className) =>
                            `<span class="${className}"><span></span></span>`,
                    },
                },
            ).on('slideChange', () => {
                this.currentSlide = this.gallery.realIndex;
                this.setScrollbarLeftSizeOffset();
            });
        },

        slideTo(slide) {
            this.gallery.slideTo(slide);
        },

        setScrollbarLeftSizeOffset() {
            if (!this.isDarkVariant) return;

            const element = document.querySelector(
                '.swiper-container' +
                    (this.customSliderClass
                        ? `.${this.customSliderClass}`
                        : '.thumbslider__content'),
            );
            const scrollBar = document.querySelector('.swiper-scrollbar');
            if (!element || !scrollBar) return;

            const leftOffset = element.getBoundingClientRect().left - 30; // 30px is the padding of the container
            scrollBar.style.left = `${leftOffset}px`;
        },
    },
});
